var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-list"},[_vm._l((_vm.list),function(item){return [_c('menu-item',_vm._b({on:{"to":function($event){return _vm.$emit('to', $event)}}},'menu-item',item,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }